import { render, staticRenderFns } from "./ItemsSelector.vue?vue&type=template&id=297325c2&scoped=true"
import script from "./ItemsSelector.vue?vue&type=script&lang=js"
export * from "./ItemsSelector.vue?vue&type=script&lang=js"
import style0 from "./ItemsSelector.vue?vue&type=style&index=0&id=297325c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297325c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('297325c2')) {
      api.createRecord('297325c2', component.options)
    } else {
      api.reload('297325c2', component.options)
    }
    module.hot.accept("./ItemsSelector.vue?vue&type=template&id=297325c2&scoped=true", function () {
      api.rerender('297325c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/ItemsSelector.vue"
export default component.exports